import {environment} from 'environments/environment';

export const INFORMO_INTENSITY_COLORS = {
  'intensity1': '#91FF91',
  'intensity2': '#52FF31',
  'intensity3': '#08CC22',
  'intensity4': '#037C1B',
  'intensity5': '#FFFF00',
  'intensity6': '#FF8040',
  'intensity7': '#6600FF',
  'intensity8': '#6600FF',
  'intensity9': '#663300',
};

export const INFORMO_INTENSITY_RANGES = [
  '0-100',
  '100-500',
  '500-1000',
  '1000-2000',
  '2000-3000',
  '3000-5000',
  'NODATA',
  'NODATA',
  '5000-10000',
];

export const VEHICLE_CERO = 0;
export const VEHICLE_ECO = 1;
export const VEHICLE_C = 2;
export const VEHICLE_B = 3;
export const VEHICLE_NOTAG = 4;
export const VEHICLE_ERROR = 5;

export const PLATES_EXCEPTIONS_LINKS = {
  [VEHICLE_ECO]: 'https://www.madrid360.es/como-me-afecta/etiqueta-eco/',
  [VEHICLE_CERO]: 'https://www.madrid360.es/como-me-afecta/etiqueta-0/',
  [VEHICLE_C]: 'https://www.madrid360.es/como-me-afecta/etiqueta-c/',
  [VEHICLE_B]: 'https://www.madrid360.es/como-me-afecta/etiqueta-b/',
  [VEHICLE_NOTAG]: 'https://www.madrid360.es/como-me-afecta/etiqueta-a/',
}

export const SER_PARKING_NO_ALL = 0;
export const SER_PARKING_NO_WITH_RESTRICTIONS = 1;
export const SER_PARKING_WITHOUT_RESTRICTIONS = 2;

export const PLATES_EXCEPTIONS_SER_PARKING = {
  [SER_PARKING_NO_ALL]: 'No, en ningún caso',
  [SER_PARKING_NO_WITH_RESTRICTIONS]: 'No, salvo excepciones en el mismo enlace',
  [SER_PARKING_WITHOUT_RESTRICTIONS]: 'Si, Sin restricciones',
}

export const PLATES_RESTRICTIONS_CODE = {
  ERROR: 0,
  ONLY_ZBEDEP_CENTRO: 1,
  NO_RESTRICTION: 2,
  SCENARIO_3: 4,
  SCENARIO_4_ALL: 5,
  SCENARIO_4_M30: 6,
  SCENARIO_5_ALL: 7,
  INSIDE_M30: 8,
}

export const PLATES_TEXT_SQL = `SELECT * FROM \`${environment.carto.tablePrefix}.madrid_traffic_pollution_scenarios\` WHERE codigo = @code`



// WEBPACK FOOTER //
// ./src/app/cities/informo/informo.const.ts